import { SHOP_STATE_KEY } from '../../action-types';

export const CLOSE_SHOP_MODAL = `${SHOP_STATE_KEY}/CLOSE_MODAL`;
export const OPEN_SHOP_MODAL = `${SHOP_STATE_KEY}/OPEN_MODAL`;
export const OPEN_ADD_TO_CART_MODAL = `${SHOP_STATE_KEY}/OPEN_ADD_TO_CART_MODAL`;
export const CLOSE_ADD_TO_CART_MODAL = `${SHOP_STATE_KEY}/CLOSE_ADD_TO_CART_MODAL`;
